var map = {
	"./recommend_AM_0.png": "5835",
	"./recommend_AM_1.png": "4016",
	"./recommend_AM_2.png": "7954",
	"./recommend_AM_3.png": "06e1",
	"./recommend_CB_0.png": "57ec",
	"./recommend_CB_1.png": "f446",
	"./recommend_CB_2.png": "60b4",
	"./recommend_CB_3.png": "f3d1",
	"./recommend_CF_0.png": "f250",
	"./recommend_CF_1.png": "d847",
	"./recommend_CF_2.png": "ee02",
	"./recommend_CF_3.png": "a25e8",
	"./recommend_CM_0.png": "7a87",
	"./recommend_CM_1.png": "11b9",
	"./recommend_CM_2.png": "5db6",
	"./recommend_CM_3.png": "67d5",
	"./recommend_DM_0.png": "3399",
	"./recommend_DM_1.png": "7b57",
	"./recommend_DM_2.png": "a96a",
	"./recommend_DM_3.png": "906f",
	"./recommend_FB_0.png": "8e52",
	"./recommend_FB_1.png": "6599",
	"./recommend_FB_2.png": "3823",
	"./recommend_FB_3.png": "82e2",
	"./recommend_GK_0.png": "adac",
	"./recommend_GK_1.png": "a696",
	"./recommend_GK_2.png": "a46f",
	"./recommend_GK_3.png": "e8ab",
	"./recommend_SS_0.png": "b516",
	"./recommend_SS_1.png": "1e41",
	"./recommend_SS_2.png": "62f8",
	"./recommend_SS_3.png": "bd50",
	"./recommend_WB_0.png": "9d6f",
	"./recommend_WB_1.png": "b28b",
	"./recommend_WB_2.png": "c58f",
	"./recommend_WB_3.png": "8001",
	"./recommend_WF_0.png": "ece2",
	"./recommend_WF_1.png": "1e5b",
	"./recommend_WF_2.png": "9241",
	"./recommend_WF_3.png": "8d6d",
	"./recommend_WM_0.png": "1ea9",
	"./recommend_WM_1.png": "c49e",
	"./recommend_WM_2.png": "5e28",
	"./recommend_WM_3.png": "768e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed5e";